import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@zola/zola-ui';

import { Field } from 'redux-form';
import { RenderField, RenderCheckboxRadioField, RenderDropdownSelect } from '../../form';
import * as Validations from '../../form/commonValidations';
import { Prefix } from '../../../manage/guestlist/GuestListTypes';

class RenderGuestRow extends React.Component {
  getGuestValue(name, index) {
    const { guestFormValues } = this.props;
    return guestFormValues && guestFormValues[index] && guestFormValues[index][name];
  }

  getFirstNameRequiredProps(index) {
    return this.getGuestValue('plus_one', index) ? {} : {
      required: true,
      validate: [Validations.REQUIRED, Validations.MAX_LENGTH_50]
    };
  }

  getFamilyNameRequiredProps(index) {
    const isPrimary = this.getGuestValue('relationship_type', index) === 'PRIMARY';
    const isPartner = this.getGuestValue('relationship_type', index) === 'PARTNER';
    if (isPrimary) {
      return isPrimary ? { required: true, validate: [Validations.REQUIRED, Validations.MAX_LENGTH_50] } : {};
    } if (isPartner) {
      return isPartner ? { required: true, validate: [Validations.MAX_LENGTH_50] } : {};
    }
    return undefined;
  }

  renderPrefixInput(guest, index) {
    if (this.getGuestValue('relationship_type', index) === 'CHILD') {
      return <input className="form-control with-tooltip-override" value="Child" disabled />;
    } if (this.getGuestValue('name_unknown', index)) {
      return <input className="form-control with-tooltip-override" value="Guest" disabled />;
    }
    return (
      <Field
        name={`${guest}.prefix`}
        id="edit-guest-group-prefix"
        options={Prefix}
        component={RenderDropdownSelect}
        hideFormGroup
        tooltip="Addressing your invitations formally? Include titles for your guests."
        validate={Validations.MAX_LENGTH_20}
      />
    );
  }

  renderNameUnknownPlaceholder() {
    return <input className="form-control" type="text" disabled />;
  }

  render() {
    const { name, index, fields, enablePlusOne, onAddGuest } = this.props;
    const guest = name;
    const isPrimary = this.getGuestValue('relationship_type', index) === 'PRIMARY';
    return (
      <div key={index} className="row form-group">
        <div className="col-xs-12 col-md-2">
          <div className="visible-xs visible-sm">
            <div className="form-label">Title <div className="with-tooltip" data-tooltip="Addressing your invitations formally? Include titles for your guests."><i className="zolaicon zolaicon-info" /></div></div>
            {this.renderPrefixInput(guest, index)}
          </div>
          <div className="hidden-xs hidden-sm">
            {this.renderPrefixInput(guest, index)}
          </div>
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="visible-xs visible-sm">
            <div className="form-label">First Name <span className="text-danger danger-asterisk">*</span></div>
          </div>
          {this.getGuestValue('name_unknown', index) && this.renderNameUnknownPlaceholder()}
          {!this.getGuestValue('name_unknown', index) && (
            <Field
              name={`${guest}.first_name`}
              id="add-guest-group-first-name"
              type="text"
              component={RenderField}
              required
              validate={[Validations.REQUIRED, Validations.MAX_LENGTH_50]}
              disabled={this.getGuestValue('name_unknown', index)}
              hideValue={this.getGuestValue('name_unknown', index)}
              hideFormGroup
            />
          )}
        </div>
        <div className="col-xs-12 col-md-4">
          <div className="visible-xs visible-sm">
            <div className="form-label">Last Name {isPrimary && <span className="text-danger danger-asterisk">*</span>}</div>
          </div>
          {this.getGuestValue('name_unknown', index) && this.renderNameUnknownPlaceholder()}
          {!this.getGuestValue('name_unknown', index) && (
            <Field
              name={`${guest}.family_name`}
              id="add-guest-group-family-name"
              type="text"
              component={RenderField}
              {...this.getFamilyNameRequiredProps(index)}
              disabled={this.getGuestValue('name_unknown', index)}
              hideFormGroup
            />
          )}
        </div>
        <div className="col-xs-12 col-md-2 visible-xs visible-sm">
          <div className="form-label">Suffix</div>
          {index > 0 && (
            <div className="guest-delete" onClick={() => fields.remove(index)}>X</div>
          )}
          {this.getGuestValue('name_unknown', index) && this.renderNameUnknownPlaceholder()}
          {!this.getGuestValue('name_unknown', index) && (
            <Field
              name={`${guest}.suffix`}
              id="add-guest-group-suffix"
              type="text"
              component={RenderField}
              disabled={this.getGuestValue('name_unknown', index)}
              hideFormGroup
              validate={Validations.MAX_LENGTH_20}
            />
          )}
        </div>
        <div className="col-xs-12 col-md-2 visible-md visible-lg">
          {index > 0 && (
            <div className="guest-delete" onClick={() => fields.remove(index)}>
              <div className="with-tooltip" data-tooltip="Delete guest">X</div>
            </div>
          )}
          {this.getGuestValue('name_unknown', index) && this.renderNameUnknownPlaceholder()}
          {!this.getGuestValue('name_unknown', index) && (
            <Field
              name={`${guest}.suffix`}
              id="add-guest-group-suffix"
              type="text"
              component={RenderField}
              disabled={this.getGuestValue('name_unknown', index)}
              hideFormGroup
              validate={Validations.MAX_LENGTH_20}
            />
          )}
        </div>
        {enablePlusOne && index === 0 && (
          <div className="col-xs-12 margin-top">
            <div className="with-tooltip" data-tooltip="Control who brings a plus-one.">
              <Link role="button" className="plus-one-btn" onClick={() => onAddGuest('PARTNER')}>
                + Add Plus One
              </Link>
              <i className="zolaicon zolaicon-info visible-xs-inline visible-sm-inline margin-left-2x" />
            </div>
          </div>
        )}
        {index > 0 && (
          <div className="col-xs-12">
            <div className="with-tooltip" data-tooltip="Check off if you don't know a guest's or plus-one's name.">
              <Field
                id={`${guest}-add-guest-group-name-unknown`}
                name={`${guest}.name_unknown`}
                component={RenderCheckboxRadioField}
                type="checkbox"
                label="Name Unknown"
                styleOverride
                className="col-xs-10 col-md-12"
              />
              <span className="zolaicon zolaicon-info guest-unknown-zolaicon visible-xs visible-sm col-xs-2" />
            </div>
          </div>
        )}
        {(index === fields.length - 1) && (
          <div className="col-xs-12">
            <Link role="button" onClick={() => onAddGuest('CHILD')}>+ Add Child</Link>
          </div>
        )}
      </div>
    );
  }
}

RenderGuestRow.propTypes = {
  name: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  fields: PropTypes.shape({}).isRequired,
  enablePlusOne: PropTypes.bool.isRequired,
  guestFormValues: PropTypes.arrayOf(PropTypes.shape({})),
  onAddGuest: PropTypes.func,
};

export default RenderGuestRow;



// WEBPACK FOOTER //
// ./src/components/common/modals/EditGuestGroupWeddingsModal/RenderGuestRow.jsx